import styled from "styled-components";
import theme from "~/styles/theme";

export const CardHolder = styled.div`
  text-align: left;
  padding: 24px;
  border-radius: 32px;
  background-color: ${(props) =>
    props.theme === "purple"
      ? theme.palette.brand.secondary.key
      : theme.palette.brand.terciary.key};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  height: 284px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    height: 352px;
    padding: 40px;
  }

  &:hover {
    background-color: ${(props) =>
      props.theme === "purple" ? "#E8ADFF" : "#FFBB33"};
  }

  * {
    color: ${theme.palette.neutral.primary.key};
    text-decoration: none;

    h4 {
      font-weight: 700;
    }

    p {
      font-size: 20px !important;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        font-size: 24px !important;
      }
    }

    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      justify-content: space-between;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        justify-content: flex-start;
      }
      svg {
        margin-left: 10px;
        fill: ${theme.palette.neutral.primary.key};
      }
    }
  }
`;
